// extracted by mini-css-extract-plugin
module.exports = {"container":"FileUpload_container__17NEy","dropTarget":"FileUpload_dropTarget__2653B","active":"FileUpload_active__2yikE"};